
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/embed",
      function () {
        return require("private-next-pages/site/embed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/embed"])
      });
    }
  